import { Log } from '../../types/utils/common'

export const getUrgentString = (log: Log | undefined | null) => {
  if (log) {
    const logKeys = Object.keys(log)
    for (const logKey of logKeys) {
      const logEntry = log[parseInt(logKey, 10)]
      if (!logEntry) continue
      if (logEntry.urgent) return `From log - ${logEntry.text}`
    }
  }
  return undefined
}
